<script lang="ts">
  import CartWidgetComponentV2 from "@retailer/svelte/CartWidget/v2/CartWidgetComponentV2.svelte";
  import { Icon } from "@getprovi/craft-svelte";
  import { InfoCircleSolid } from "@getprovi/craft-svelte-icons";
  import * as pluralize from "@shared/svelte/Modules/pluralize";
  import { isSupplier } from "@shared/services/internal_user_check_helpers.js";

  import { OHLQ_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let cartWidgetItem: any;
  export let newCaseQuantity: number;
  export let newUnitQuantity: number;
  export let widgetAtDefaultMax: boolean;

  const DEFAULT_MAX = 999;

  const onUpdateQuantity = async (event: CustomEvent) => {
    if (event.detail.quantityType === "case") {
      newCaseQuantity = event.detail.newQuantity;
    }
    if (event.detail.quantityType === "unit") {
      newUnitQuantity = event.detail.newQuantity;
    }

    const containerCaseSize = cartWidgetItem.product_summary.container_case_size;
    const totalQuantity = newCaseQuantity * containerCaseSize + newUnitQuantity;
    widgetAtDefaultMax =
      (newUnitQuantity > DEFAULT_MAX ||
        newCaseQuantity * containerCaseSize > DEFAULT_MAX ||
        totalQuantity > DEFAULT_MAX) &&
      cartWidgetItem.distributor_summary.id === OHLQ_DISTRIBUTOR_ID;
  };

  const disabled = isSupplier();
</script>

<div class="fizz-full-width fizz-flow-8">
  {#each cartWidgetItem.buying_options as option}
    <CartWidgetComponentV2
      {option}
      {disabled}
      disableIncrement={false}
      inventoryId={cartWidgetItem.inventory_id}
      containerType={pluralize.singular(option.label)}
      stockLevel={cartWidgetItem.stock_info?.level}
      on:updateQuantity={onUpdateQuantity}
    />
  {/each}
  {#if widgetAtDefaultMax}
    <div
      class="fizz-flex-row fizz-text-small fizz-text-negative align-left"
      data-testid="max-quantity-error"
    >
      <Icon iconName={InfoCircleSolid} size="icon-base" class="fizz-inline-4" />
      <span class="fizz-inline-4">Max quantity is 999</span>
    </div>
  {/if}
</div>
